export interface SiteSnapshot {
  date: string;
  visits: number;
  uniqueVisitors: number;
  pageviews: number;
}

export interface DashboardSite {
  id: number;
  hostname: string;
  displayName: string;
  snapshots: SiteSnapshot[];
}

export interface DashboardBrand {
  id: number;
  slug: string;
  displayName: string;
  sites: DashboardSite[];
}

export interface DashboardCompany {
  id: number;
  slug: string;
  displayName: string;
  brands: DashboardBrand[];
}

export interface DashboardResponse {
  generatedAt: number;
  rangeDays: number;
  companies: DashboardCompany[];
}

const API_BASE = import.meta.env.VITE_API_BASE || "";

export async function fetchDashboard(days = 30): Promise<DashboardResponse> {
  const res = await fetch(`${API_BASE}/api/dashboard?days=${days}`, {
    credentials: "include",
  });
  if (!res.ok) throw new Error(`API ${res.status}: ${await res.text()}`);
  return res.json();
}

// Mock data for local development before the API is wired up.
export function mockDashboard(): DashboardResponse {
  const today = new Date();
  const makeSnapshots = (base: number, variance: number, days: number): SiteSnapshot[] => {
    const arr: SiteSnapshot[] = [];
    for (let i = days - 1; i >= 0; i--) {
      const d = new Date(today.getTime() - i * 86400000);
      const seed = Math.sin(i * 1.7 + base) * 0.5 + 0.5;
      const visits = Math.max(0, Math.round(base + seed * variance));
      arr.push({
        date: d.toISOString().slice(0, 10),
        visits,
        uniqueVisitors: Math.round(visits * 0.85),
        pageviews: Math.round(visits * 2.4),
      });
    }
    return arr;
  };

  return {
    generatedAt: Date.now(),
    rangeDays: 30,
    companies: [
      {
        id: 1, slug: "vault", displayName: "株式会社VAULT",
        brands: [
          {
            id: 1, slug: "capture-gears", displayName: "Capture Gears",
            sites: [
              { id: 1, hostname: "capturegears.jp",   displayName: "capturegears.jp", snapshots: makeSnapshots(42, 30, 30) },
              { id: 2, hostname: "xgrids.uphash.net", displayName: "XGRIDS Japan",    snapshots: makeSnapshots(28, 22, 30) },
            ],
          },
        ],
      },
      {
        id: 2, slug: "uphash", displayName: "UPHASH Inc.",
        brands: [
          {
            id: 3, slug: "corporate", displayName: "Corporate",
            sites: [
              { id: 3, hostname: "uphash.net", displayName: "uphash.net", snapshots: makeSnapshots(67, 45, 30) },
            ],
          },
        ],
      },
      {
        id: 3, slug: "okuguruwa", displayName: "株式会社奥廓",
        brands: [
          {
            id: 5, slug: "corporate", displayName: "Corporate",
            sites: [
              { id: 4, hostname: "okuguruwa.com", displayName: "okuguruwa.com", snapshots: makeSnapshots(15, 12, 30) },
            ],
          },
        ],
      },
    ],
  };
}
